import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export const PAYOUT_ROLES = ["booker", "salesman", "developer"];

export default function ProtectedRoute({
  children,
  requireAdmin = false,
  allowResendStaff = false,
  allowTeamStaff = false,
  allowEkycStaff = false,
  allowDeliveryMan = false,
  allowPayout = false,
}) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5F5F0]">
        <div className="font-mono text-sm text-[#6B6B61]" data-testid="auth-loading">
          Checking session…
        </div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  // Resend-only staff are confined to /resend-only — any other route bounces
  // them straight back (URL-direct attempts blocked too).
  if (user.role === "resend_staff" && !allowResendStaff) {
    return <Navigate to="/resend-only" replace />;
  }
  // Team staff can only see their own ledger — any other route bounces back.
  if (user.role === "team_staff" && !allowTeamStaff) {
    return <Navigate to="/my-ledger" replace />;
  }
  if (user.role === "delivery_man" && !allowDeliveryMan) {
    return <Navigate to="/delivery" replace />;
  }
  if (user.role === "ekyc_staff" && !allowEkycStaff) {
    return <Navigate to="/ekyc-desk" replace />;
  }
  if (PAYOUT_ROLES.includes(user.role) !== allowPayout) {
    return <Navigate to={allowPayout ? "/" : "/my-payout"} replace />;
  }
  if (requireAdmin && user.role !== "admin") return <Navigate to="/chat" replace />;
  return children;
}
